export const consentManagement = {
  consentManagementDialog: {
    labelDecline: 'Widerrufen',
    labelCancel: 'Abbrechen',
    termsAndConditions: 'Allgemeine Geschäftsbedingungen',
    noTermsConditions_line1: 'Möchten Sie die Zustimmung zu den Allgmeinen Geschäftsbedingungen wirklich widerrufen?',
    noTermsConditions_line2: 'Dies führt zu einer sofortigen Abmeldung vom Webshop.',
  }
};
